export const Select_Different_Airport = 'Select Different Airport';

export const Vacation_Date_Config = {
  month: 'short' as const,
  day: 'numeric' as const,
  timezone: 'UTC' as const,
  locale: 'en-US' as const
};
